import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StyledReturnButton } from "./ReturnButton.styled";
import { BreadCrumbData } from "@shared/lib/navigation/Breadcrumbs.types";
import { getBreadcrumbsData, getLasAvailableBreadCrumb } from "@shared/lib/navigation/breadcrumbs";
import { parseDocumentSettingsIdToNumber } from "@features/documents/utils/documentSettings";
import { DocumentSettings } from "@models/document-settings";
import { RootState } from "@app/store";

type State = {
  breadcrumbData?: BreadCrumbData[];
};

function ReturnButton() {
  const location = useLocation();
  const { state } = useLocation() as { state: State };
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [breadCrumbToReturn, setBreadCrumbToReturn] = useState<BreadCrumbData>();

  const documentSettingsId: number | null = parseDocumentSettingsIdToNumber(searchParams.get("documentType"));
  const documentsSettings: DocumentSettings[] | undefined = useSelector(
    (state: RootState) => state.documents.settings,
  );

  const breadCrumbsData: BreadCrumbData[] = getBreadcrumbsData(
    location.pathname,
    documentsSettings?.find((settings) => settings.id === documentSettingsId),
    location.state?.breadcrumbData,
  );

  useEffect(() => {
    try {
      setBreadCrumbToReturn(getLasAvailableBreadCrumb(breadCrumbsData));
    } catch {}
  }, [state]);

  function handleReturn(breadcrumbToReturn?: BreadCrumbData): void {
    if (breadcrumbToReturn) {
      navigate(breadcrumbToReturn.link!, {
        replace: true,
        state: {
          ...breadcrumbToReturn.state,
        },
      });
    }
  }

  return (
    <StyledReturnButton>
      {breadCrumbToReturn ? (
        <Button variant="outlined" onClick={() => handleReturn(breadCrumbToReturn)}>
          חזור
        </Button>
      ) : null}
    </StyledReturnButton>
  );
}

export default ReturnButton;
